import { getStoryBySlug } from '@cinch-nx/data-storyblok'
import { traceFunction } from '@core/datadog-server'
import { GetStaticPropsContext, InferGetStaticPropsType } from 'next'
import { ReturnsStory } from './storyblok/storyblok'
import { returnsFallbackStory } from './storyblok/data/fallback-json'

const isDev = process.env.STAGE_NAME !== 'production'
const STORYBLOK_BFF_URL = 'https://storyblok-bff.snc-prod.aws.cinch.co.uk'
const STORYBLOK_SLUG = 'returns'

async function getStory(preview: boolean) {
  try {
    return await getStoryBySlug<ReturnsStory>(
      STORYBLOK_SLUG,
      {
        version: preview || isDev ? 'draft' : 'published',
      },

      { strict: true, urlDomain: STORYBLOK_BFF_URL },
    )
  } catch {
    return returnsFallbackStory
  }
}

export async function getStaticPropsfn({
  preview = false,
}: GetStaticPropsContext) {
  const story = await getStory(preview)

  return {
    props: {
      story,
      preview,
      layoutProps: {
        heroProps: story.content.hero[0],
        showBorderRadius: true,
      },
    },
    revalidate: 60,
  }
}

export const getStaticProps = traceFunction(
  'returns.getStaticProps',
  getStaticPropsfn,
)

export type ReturnsProps = InferGetStaticPropsType<typeof getStaticProps>
